export const rackMode = {
  selectedColumn: 'selectedColumn',
  selectedLevel: 'selectedLevel',
  selectedCell: 'selectedCell',
  selectedRack: 'selectedRack',
  createRack: 'createRack',
  noSelected: 'noSelected',
};
